// Pages
import { ActivityStudentDashboard } from "./activity-student-dashboard.page";

export default ActivityStudentDashboard;
